import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "menu-list" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isTop ? 'header' : 'header is-scroll' )
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "logo" }, [
      _createElementVNode("h1", null, [
        _createElementVNode("i", {
          class: "iconfont iconLOGO",
          style: {"font-size":"112px","color":"#428FEF","font-weight":"400"}
        }),
        _createTextVNode(" 捍御者LOGO ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (item, index) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "menu-item",
          key: index,
          onClick: ($event: any) => (_ctx.handleClick(index))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.currentMenuIndex === index ? 'active text': 'text')
          }, _toDisplayString(item.text), 3)
        ], 8, _hoisted_2))
      }), 128)),
      _cache[0] || (_cache[0] = _createElementVNode("span", { style: {"position":"absolute","left":"522.891px","bottom":"0px","width":"112px","height":"2px","z-index":"-1","opacity":"1"} }, null, -1))
    ])
  ], 2))
}